import { Button, ButtonProps, CircularProgress } from '@material-ui/core';
import React, { FunctionComponent } from 'react';


type LoadingButtonProps = {
    loading: boolean
} & ButtonProps

export const LoadingButton: FunctionComponent<LoadingButtonProps> = ({ loading, children, ...props }) => {
    return (
        <Button disabled={loading} {...props}>
            {children}&nbsp;{loading && <CircularProgress color="secondary" size={20} />}
        </Button>
    )
}